import { dataProps } from './properties'

export const setUserGroupList = (state, payload) => {
    state.list = payload
}    

export const setUserGroupData = (state, payload) => {
    state.props = payload.response
    if(payload.copy) {
        state.props.access_module_list.forEach(element => {
            element.id = 0
        })
    }
} 

export const resetUserGroupData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/userGroup/mutations.js